export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/sort_normal@2x.png";